(function () {
  'use strict';
  var STORE = 'bensnaturalhealth'; // Reviews.io store id
  var API_URLS = [
    'https://api.reviews.io/product/rating-batch',
    'https://api.reviews.co.uk/product/rating-batch'
  ];
  var cache = {};
  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Card Reviews]');
    console.log.apply(console, args);
  }
  function cleanSkus(raw) {
    var list = [];
    (raw || '').split(/[;,]/).forEach(function (s) {
      s = s.trim();
      if (s && list.indexOf(s) === -1) list.push(s);
    });
    return list;
  }
  function num(v) {
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }
  function combine(data) {
    var rows = Array.isArray(data) ? data : (data && (data.data || data.products || data.ratings)) || [];
    if (!Array.isArray(rows)) rows = Object.keys(rows).map(function (k) { return rows[k]; });
    var weighted = 0;
    var total = 0;
    rows.forEach(function (row) {
      if (!row) return;
      var count = num(row.num_ratings || row.num_reviews || row.count || row.total || row.review_count);
      var avg = num(row.average_rating || row.rating || row.average || row.avg_rating);
      if (count > 0 && avg > 0) {
        weighted += avg * count;
        total += count;
      }
    });
    if (!total) return null;
    return { rating: weighted / total, count: total };
  }
  function fetchGroupRating(skus) {
    var key = skus.join(';');
    if (cache[key]) return cache[key];
    var query = '?store=' + encodeURIComponent(STORE) + '&sku=' + encodeURIComponent(key);
    cache[key] = (function tryUrl(i) {
      if (i >= API_URLS.length) return Promise.resolve(null);
      return fetch(API_URLS[i] + query, { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (json) {
          var result = combine(json);
          log('SKUs', key, '→', result || 'no reviews', json);
          return result;
        })
        .catch(function (err) {
          log('API failed at', API_URLS[i], err.message);
          return tryUrl(i + 1);
        });
    })(0);
    return cache[key];
  }
  function readSnippet(block) {
    var snippet = block.querySelector('.ruk_rating_snippet');
    if (!snippet || snippet.getAttribute('data-done') !== 'true') return null;
    var el = snippet.hasAttribute('title') ? snippet : snippet.querySelector('[title]');
    var text = (el && el.getAttribute('title')) || snippet.textContent || '';
    var r = text.match(/(\d+(?:\.\d+)?)/);
    var c = text.match(/(\d[\d,]*)\s*Review/i);
    if (!r || !c) return null;
    var count = parseInt(c[1].replace(/,/g, ''), 10);
    return count ? { rating: parseFloat(r[1]), count: count } : null;
  }
  function render(block, data) {
    var wrapper = block.querySelector('.custom-rating-wrapper');
    if (!wrapper || !data) return;
    wrapper.querySelector('.dynamic-num-score').textContent = (Math.round(data.rating * 100) / 100) + '/5';
    wrapper.querySelector('.dynamic-total-reviews').textContent = data.count + ' Reviews';
    wrapper.querySelectorAll('.star-icon__clip').forEach(function (clip, i) {
      var diff = data.rating - i;
      clip.style.width = (diff >= 1 ? 100 : diff <= 0 ? 0 : Math.round(diff * 100)) + '%';
    });
    wrapper.removeAttribute('hidden');
    wrapper.style.display = 'flex';
  }
  function handleBlock(block) {
    if (block.dataset.reviewsHandled === 'true') return;
    block.dataset.reviewsHandled = 'true';
    var snippet = block.querySelector('.ruk_rating_snippet');
    var skus = cleanSkus(snippet ? snippet.getAttribute('data-sku') : block.dataset.sku);
    if (!skus.length) return;
    fetchGroupRating(skus).then(function (data) {
      render(block, data || readSnippet(block));
    });
  }
  function init(root) {
    (root || document)
      .querySelectorAll('.reviews-block-wrapper[data-review-mode="sku-group"]')
      .forEach(handleBlock);
  }
  function start() {
    init();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) init(node.matches && node.matches('.reviews-block-wrapper') ? node.parentNode : node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.initCardReviews = init;
})();